import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { ArrowClockwise, PlayCircle } from "@phosphor-icons/react";
import { fmtNum } from "./meta";

const ST = { running: "En cours", success: "Réussie", partial: "Partielle", error: "Erreur" };
const COLOR = { running: "text-accent", success: "text-accent", partial: "text-amber-500", error: "text-destructive" };

export default function LeadSync() {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/leads/sync/jobs").then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, []);
  const run = async () => {
    try { await api.post("/admin/leads/sync/run"); toast.success("Synchronisation lancée"); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  if (!d) return <div className="text-muted text-sm animate-pulse">Chargement…</div>;
  const lastOk = d.jobs.find((j) => j.status === "success" || j.status === "partial");
  return (
    <div className="space-y-4" data-testid="lead-sync">
      <div className="surface rounded-lg p-5 flex flex-wrap items-center justify-between gap-4">
        <div className="text-sm">
          <div className="text-fg">Dernière exécution réussie : <b data-testid="lead-sync-last-ok">{lastOk ? new Date(lastOk.finished_at || lastOk.started_at).toLocaleString("fr-FR") : "—"}</b></div>
          <div className="text-xs text-muted mt-1">Automatique chaque nuit (04:30 UTC). Historique BODACC importé depuis {d.bodacc_history.since || "—"} pour {fmtNum(d.bodacc_history.companies_done)} ESN.</div>
        </div>
        <button onClick={run} disabled={d.running} data-testid="lead-sync-run-btn"
          className="flex items-center gap-2 bg-accent text-black font-semibold rounded-md px-4 py-2 text-sm hover-lift disabled:opacity-60">
          {d.running ? <><ArrowClockwise size={15} className="animate-spin" /> Synchronisation en cours…</> : <><PlayCircle size={15} weight="fill" /> Synchroniser maintenant</>}
        </button>
      </div>
      <div className="surface rounded-lg overflow-x-auto" data-testid="lead-sync-jobs">
        <table className="w-full text-xs">
          <thead className="bg-surface-2/60 text-muted"><tr>{["Début", "Type", "Durée", "Statut", "Annonces analysées", "Entreprises ajoutées", "Entreprises actualisées", "Événements", "Erreurs", "Étapes"].map((h) => <th key={h} className="text-left p-2 font-medium">{h}</th>)}</tr></thead>
          <tbody>
            {d.jobs.map((j) => (
              <tr key={j.job_id} className="border-t border-border/60 align-top" data-testid={`lead-job-${j.job_id}`}>
                <td className="p-2 text-fg whitespace-nowrap">{new Date(j.started_at).toLocaleString("fr-FR")}</td>
                <td className="p-2 text-muted">{j.kind === "daily" ? "Quotidienne" : `Manuelle (${j.triggered_by})`}</td>
                <td className="p-2 text-muted">{j.duration_s != null ? `${j.duration_s} s` : "—"}</td>
                <td className={`p-2 font-medium ${COLOR[j.status]}`}>{ST[j.status] || j.status}</td>
                <td className="p-2">{fmtNum(j.stats?.announcements_analysed)}</td>
                <td className="p-2">{fmtNum(j.stats?.companies_added)}</td>
                <td className="p-2">{fmtNum(j.stats?.companies_updated)}</td>
                <td className="p-2">{fmtNum(j.stats?.events_added)}</td>
                <td className="p-2" title={(j.errors || []).join("\n")}>{fmtNum(j.stats?.errors)}{j.errors?.length ? <div className="text-[10px] text-destructive max-w-[220px]">{j.errors[0]}</div> : null}</td>
                <td className="p-2 text-[10px] text-muted">{Object.entries(j.steps || {}).map(([k, v]) => `${k}: ${v.status}`).join(" · ")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
